export enum PersonalizeStatusEnum {
  NEW_PERSONALISATION = 'new_personalisation',
  PERSONALISED = 'personalised',
  SEND_NEW_CARD = 'send_new_card',
  SEND_UPDATED_CARD = 'send_updated_card',
  SENT_TO_BANK = 'sent_to_bank',
  INVALID_PERSONALISATION = 'invalid_personalisation',
}
